import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const Header = ({ onSubmit }) => {
  const { t } = useTranslation("admClass");
  const { markingAttendance: loading } = useSelector(
    (state) => state.admin.staffAttendance
  );

  return (
    <div className="flex justify-between px-4 w-full mb-2">
      <button
        className="px-6 py-2 w-full btn-gradient transform transition-all duration-300 ease-in-out  "
        onClick={onSubmit}
      >
        {loading ? t("Please wait..") : t("Submit Attendance")}
      </button>
    </div>
  );
};

export default Header;
